const ERROR_FIELD_SELECTOR = ".form-field-controll-error";

/**
 * onInvalid handler for react-hook-form's handleSubmit. Scrolls the topmost
 * errored field into view so the user isn't left guessing what blocked the
 * submit — matches the behaviour of the other forms in the app.
 *
 * Deferred across two animation frames because handleSubmit fires the invalid
 * callback before React has painted the error styles into the DOM.
 */
export const scrollToFirstError = () => {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      const erroredFields = Array.from(
        document.querySelectorAll(ERROR_FIELD_SELECTOR)
      );

      if (erroredFields.length === 0) return;

      const topMostErroredField = erroredFields.reduce((topMost, field) =>
        field.getBoundingClientRect().top <
        topMost.getBoundingClientRect().top
          ? field
          : topMost
      );

      topMostErroredField.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    });
  });
};
